import {
  addMonths,
  endOfMonth,
  isAfter,
  parseISO,
  startOfDay,
  subDays,
  subMonths,
} from 'date-fns';
import { getUnixEndOfDay, getUnixStartOfDay } from 'helpers/DateHelper';

const parseAccountDate = value => {
  if (!value) return null;

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return startOfDay(new Date(year, month - 1, day));
  }

  const parsedDate = parseISO(value);
  return Number.isNaN(parsedDate.getTime()) ? null : startOfDay(parsedDate);
};

const anchorDateInMonth = (referenceDate, anchorDay) => {
  const year = referenceDate.getFullYear();
  const month = referenceDate.getMonth();
  const lastDay = endOfMonth(new Date(year, month, 1)).getDate();
  const day = Math.min(anchorDay, lastDay);

  return startOfDay(new Date(year, month, day));
};

export const getAccountPeriod = (
  periodStartDate,
  createdAt,
  referenceDate = new Date()
) => {
  const anchorSource =
    parseAccountDate(periodStartDate) || parseAccountDate(createdAt);
  if (!anchorSource) return null;

  const anchorDay = anchorSource.getDate();
  const today = startOfDay(referenceDate);

  let periodStart = anchorDateInMonth(today, anchorDay);
  if (isAfter(periodStart, today)) {
    periodStart = anchorDateInMonth(subMonths(today, 1), anchorDay);
  }

  const periodEnd = addMonths(periodStart, 1);
  const reportFrom = getUnixStartOfDay(periodStart);
  const reportTo = getUnixEndOfDay(subDays(periodEnd, 1));

  return { periodStart, periodEnd, reportFrom, reportTo };
};
